<template>
    <div class="product">
        <banner img="../assets/img/bgtop.jpg" title="核心理念"/>
        <div class="product-content">
            <div class="content-tow">
                <h3 class="title" style="padding-top: 20px;color: #d9a145">让零售移动起来</h3>
                <p>
                    随着互联网的普及及电子商务的迅猛发展，以零售连锁为核心商业模式的零售业，面临着诸多内忧外患。在外部，网购市场已经榨干了行业利润，新兴的竞争对手还在不断涌现；在内部，人力成本急剧上升，经营风险随时爆发，员工能力无法适应新的竞争需求，业绩不断下滑…！
                </p>
                <p style="color: #ba1515">
                    零售商不停的在思考，接下来我们将如何应对？ 零售业究竟路在何方？
                </p>
                <p>
                    但我们必须清醒的认识到，零售业作为行业发展的发动机、火车头，是一个长青的行业，拥有无限广阔的发展前景。行业发展的每一个阶段都必然存在着诸多重大的挑战和机遇，而挑战永远和机遇并存！若你先于竞争对手破解了挑战，挑战就变成了你的巨大机遇，若你无法洞悉机遇，则必然随时面临挑战！
                </p>
                <p>
                    对比以往，互联网的发展让消费者获取信息的手段更加便利及快捷，以往靠信息不对称获取高额利润的时代已经过去了，消费者有着更多更加便利的选择！
                </p>
                <p>
                    面对纷繁复杂的局势，我们需要清醒的认识到，零售的本质并没有变，依然是将产品卖给顾客，因此零售依然要解决的核心问题就是如何在正确的时间将正确的产品在正确的地方卖给正确的顾客！
                </p>
                <p style="color: #ba1515">
                    互联网的出现只是帮助我们企业做得更加正确而已！
                </p>
                <p>
                    面对未来，零售的问题将聚焦在如下三个方面：<br/>
                    &emsp;&emsp;&emsp;1、互联网的本质是什么？回答如何准确运用互联网问题！<br/>
                    &emsp;&emsp;&emsp;2、为谁而战？回答零售的动力问题！<br/>
                    &emsp;&emsp;&emsp;3、如何作战？回答零售的方法问题！<br/>
                    &emsp;&emsp;&emsp;关于互联网的本质问题，有两种核心认识思维：『互联网+』及『+互联网』<br/>
                    &emsp;&emsp;&emsp;『互联网+』是以互联网平台为主体，企业是工具，企业在非对称竞争中被淘汰<br/>
                    &emsp;&emsp;&emsp;『+互联网』是以企业为主体，互联网是工具，互联网在帮助企业实现竞争力<br/>
                    &emsp;&emsp;&emsp;『互联网+』最终成就的是平台，企业只能短期获益，『+互联网』才是企业的未来，企业只有以自身业务需求为核心构建属于自己的互联网支撑体系才能够赢得未来！
                </p>
            </div>
            <!-- 平台目标 -->
            <div class="target">
                <h3 class="title" style="color: #d9a145">为自己而战，为自己的收入而战！</h3>
                <div style="margin:10px 100px">
                    <p>
                        关于为谁而战问题，这涉及到零售的动力问题！我们调研过大量的零售员工，90%以上的员工都会不假思索的回答：为自己而战，为自己的收入而战！
                    </p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import Banner from "../components/Banner";

    export default {
        data() {
            return {
                loading: true,
                videoSrc: "http://www.shkjem.com/video/kj.mp4",
                playerOptions: {
                    playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 视频一结束就重新开始。
                    preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: "zh-CN",
                    aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [
                        {
                            type: "",
                            src: "http://www.shkjem.com/video/kj.mp4" //url地址
                        }
                    ],
                    //poster: "../assets/img/home_top.jpg", //你的封面地址
                    // width: document.documentElement.clientWidth,
                    notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true, //当前时间和持续时间的分隔符
                        durationDisplay: true, //显示持续时间
                        remainingTimeDisplay: false, //是否显示剩余时间功能
                        fullscreenToggle: true //全屏按钮
                    }
                }
            };
        },
        components: {
            Banner
        },
        created() {
            this.$http
                .get(
                    "DataDictionary/GetDataDictionaryAll?key=%E4%BA%A7%E5%93%81%E8%A7%86%E9%A2%91%E9%93%BE%E6%8E%A5"
                )
                .then(response => {
                    this.videoSrc = response.data[0].Content;
                    window.console.log(this.videoSrc);
                    this.loading = false;
                })
                .catch(function (error) {
                    window.console.log(error);
                });
        }
    };
</script>

<style lang="scss" scoped>
    .product {
        width: 100%;
        height: 100%;
        background-color: #14679f;
    }

    .product-content {
        background-color: #fff;

        .content-tow {
            margin: 0px 100px;
        }

        p {
            color: #14679f;
            font-size: 16px;
            text-align: start;
            text-indent: 25px;
            line-height: 30px;
            margin: 10px 0;
        }
    }


    //平台目标
    .target {
        margin-top: 50px;

        &-img {
            margin-top: 50px;
            text-align: center;
        }
    }

    //
    .modular {
        margin-top: 50px;

        .modular-content {
            padding: 50px 50px;
            display: flex;
            justify-content: space-around;
        }
    }

    .modular-content-same {
        width: 182px;
        height: 405px;

        .same-item {
            height: 70px;
            padding: 10px 0;
            display: flex;
            justify-content: space-between;

            .same-item-img {
                width: 70px;
                height: 70px;
                line-height: 100px;
                background: #1667a0;
                border-radius: 50%;
                text-align: center;
            }

            p {
                color: #1667a0;
                font-weight: 700;
                line-height: 70px;
            }
        }
    }

    .modular-content-center {
        width: 355px;
        height: 355px;

        img {
            width: 100%;
        }
    }

    //公共样式
    .title,
    .eTitle {
        font-size: 34px;
        font-weight: 400;
        color: #333;
        text-align: center;
    }

    .eTitle {
        font-size: 30px;
        padding: 10px 0;
    }
</style>
